import React, { useEffect } from "react";
import { getFarmacia, resetFarmaciasFlag } from "../../../slices/thunks";
import { useSelector, useDispatch } from "react-redux";
import { createSelector } from "reselect";
import { useParams } from "react-router-dom";

// Importaciones de reacciones
import {  Container,  Row,  Col,  Card,  CardBody,  CardHeader,  Alert, } from "reactstrap";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import EditarFarmacia from "./Editar";

const selectFarmaciaState = (state) => state.Farmacias;

const selectFarmaciaPageData = createSelector(
  [selectFarmaciaState],
  (farmaciaState) => ({
    farmacia: farmaciaState.farmacia,
    error: farmaciaState.error,
    loading: farmaciaState.loading,
    errorMsg: farmaciaState.errorMsg,
    colorMsg: farmaciaState.colorMsg,
    exito: farmaciaState.exito,
  })
);

const Editar = () => {
 
  // Obtiene el ID desde la URL
  const { id } = useParams();
  

  const dispatch = useDispatch();

  useEffect(() => {
    
    dispatch(getFarmacia(id));
  }, [dispatch, id]);

  const { farmacia, error, errorMsg, colorMsg, exito } =
    useSelector(selectFarmaciaPageData);



  useEffect(() => {
    
    if (errorMsg) {
      setTimeout(() => {
        dispatch(resetFarmaciasFlag());
      }, 3000);
    }
  }, [dispatch, errorMsg]);

  return (
    <div className="page-content">
      <Container fluid>
          <BreadCrumb
            title="Editar Farmacia"
            pageTitle="Listar Farmacias"
            url="/farmacias"
          />

          <Row>
            <Col lg={12}>
              <Card>
                <CardHeader className="border-0">

                  {errorMsg && errorMsg ? (
                    <Alert color={colorMsg}> {error} </Alert>
                  ) : null}
                  
                </CardHeader>
                <CardBody>
                  {exito && (
                    <EditarFarmacia farmacia={farmacia}  />
                  )}
                </CardBody>
              </Card>
            </Col>
          </Row>
      </Container>
    </div>
  );
};

export default Editar;
